import { useState } from 'react';
import { EdocViewParameter } from 'scbk-shared-module/modules/Edoc/types';
import { CLIP_PATH_MAP, ClipClient } from '../client/ClipClient';
import { EdocTranType } from '../enums';

interface RequestData extends EdocViewParameter {
  jsonParam: string;
}

export const useClip = (clipUrl: string) => {
  const [isReportReady, setIsReportReady] = useState<boolean>(false);
  const [currentPageCount, setCurrentPageCount] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [reportKey, setReportKey] = useState<string>('');

  const transfer = async (props: EdocViewParameter) => {
    const path = CLIP_PATH_MAP[props.tranType];

    if (!path) {
      throw new Error(`지원하지 않는 tranType: ${props.tranType}`);
    }

    try {
      const requestData: RequestData = {
        ...props,
        jsonParam: JSON.stringify(props.loanData ?? []),
      };

      const { data } = await ClipClient(`${clipUrl}/clip/`).post<string>(path, requestData);

      console.log('[clip] transfer data:', data);

      if (requestData.tranType === EdocTranType.LOAN) {
        return {
          trandNo: requestData.loanData?.tradNo,
          custNo: requestData.loanData?.custNo,
          edocList: getPdfList(requestData, data),
        };
      }

      return data;
    } catch (error) {
      console.error('[clip] transfer error', error);
      throw new Error(
        '전자문서 서버와 통신에 실패하였습니다. 다시 한번 시도해 주세요.<br/>계속 처리되지 않는 경우 고객컨택센터에 연락해 주세요.',
      );
    }
  };

  const getPdfList = (request: RequestData, response: any) => {
    const edocParamList = request.loanData?.edocList ?? [];

    return response.edocList.map((item: any) => {
      const mappingInfo = edocParamList.find((param) => param.edocCode === item.edocCode);

      return {
        edocCode: item.edocCode,
        elementID: item.elementID,
        edocFileName: item.edocFileName,
        edocHash: item.edocHash,
        edocSignYN: item.edocSignYN,
        edocFilePath: item.edocFilePath,
        mergePdfYN: item.mergePdfYN,
        mappingData: mappingInfo?.mappingData,
      };
    });
  };

  const view = async (wrapId: string, viewData: string) => {
    console.log('viewData > ', viewData);

    const [reportKey, serverCode] = viewData
      .trim()
      .split('|')
      .map((v: string) => v.trim());

    // 뷰어 실행
    console.log('clipView reportKey : [', reportKey, ']');
    console.log('clipView serverCode : ', serverCode);

    const urlPath = `${clipUrl}/clip/report_server.jsp`; // 'Clip 엔진서버 주소 ' + 'Clip.jsp';
    const report = window.createReport(urlPath, reportKey, document.getElementById(wrapId));

    report.setDebug(true);

    report.setViewType(1);
    report.setDefaultRatio('PageWidth');
    report.setVisibleMenu(false);
    report.setUseWebLink(false);

    // report.setMobileMoveButtonTime(-1);

    report.setRatioComboAllChange([
      { name: 'PageWidth', text: 'pageWidth', value: 'pageWidth', visible: true },
      { name: '95%', text: '95%', value: '0.95', visible: true },
      { name: '105%', text: '105%', value: '1.05', visible: true },
      { name: '115%', text: '115%', value: '1.15', visible: true },
      { name: '125%', text: '125%', value: '1.25', visible: true },
      { name: '135%', text: '135%', value: '1.35', visible: true },
      { name: '145%', text: '145%', value: '1.45', visible: true },
      { name: '155%', text: '155%', value: '1.55', visible: true },
      { name: '165%', text: '165%', value: '1.65', visible: true },
      { name: '175%', text: '175%', value: '1.75', visible: true },
      { name: '185%', text: '185%', value: '1.85', visible: true },
      { name: '195%', text: '195%', value: '1.95', visible: true },
    ]);

    report.view();

    report.setEndReportEvent(function (this: any) {
      console.log(this.objPageInfo);
      setCurrentPageCount(report.callGetSlectedPageNumber());
      setTotalPageCount(report.callGetTotalPageCount());
      setReportKey(report.callGetReportKey());
      setIsReportReady(true);
    });

    return {
      report: report,
    };
  };

  return {
    transfer,
    view,
    isReportReady,
    setIsReportReady,
    reportKey,
    currentPageCount,
    setCurrentPageCount,
    totalPageCount,
    setTotalPageCount,
  };
};
